import axios, { CancelTokenSource } from 'axios';
export const getTask = (obj: any, tokenSource?: CancelTokenSource) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL + `dig/task?org_id=` + obj.org_id,
    {
      cancelToken: tokenSource?.token,
    }
  );
};
export const getTaskByName = (taskName: string) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL +
      `dig/task-find-by-name?task_name=` +
      taskName
  );
};
export const getTableNames = (tokenSource?: CancelTokenSource) => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL + `dig/table-names`, {
    cancelToken: tokenSource?.token,
  });
};
export const getTableWithColumnNames = (
  tableName: string,
  tokenSource?: CancelTokenSource
) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL +
      `dig/table-detail?where=` +
      tableName,
    {
      cancelToken: tokenSource?.token,
    }
  );
};
export const AddTask = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `dig/task/add`, obj, {
    headers,
  });
};

export const EditTask = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `dig/task/update`,
    obj,
    {
      headers,
    }
  );
};

export const DeleteTask = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `dig/task/delete`,
    obj,
    {
      headers,
    }
  );
};

export const getTaskMapping = (id: number) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL + `dig/task/mapping?where=` + id
  );
};
export const AddTaskMapping = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `dig/task/mapping/add`,
    obj,
    { headers }
  );
};

export const EditTaskMapping = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `dig/task/mapping/update`,
    obj,
    { headers }
  );
};

export const DeleteTaskMapping = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `dig/task/mapping/delete`,
    obj,
    { headers }
  );
};
